import { useState } from 'react';
import { useQuery } from 'react-query';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import { IUserCardViewModel } from 'viewModels';
import { RemoveRedEye } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { ReactComponent as Verified } from '../../../assets/icons/Icon-ProfileCheck.svg';
import userIcon from '../../../assets/icons/iconUser.svg';
import { Download } from '../../../controller/FileController';
import { UserProfileType } from '../../../types/enums';
import { Container, AvatarWrapper, StyledCard, CardHeader, CardContent, Icon } from './styles';
import ModalViewPresentation from '../../Modals/ModalViewPresentation';

interface CardCollaboratorProps {
  currentUser: IUserCardViewModel;
  onViewDetails?: () => void;
  showEmail?: boolean;
  showDescription?: boolean;
}

export function CardCollaborator({
  currentUser,
  onViewDetails,
  showEmail,
  showDescription,
}: CardCollaboratorProps) {
  const [isOpenPresentation, setIsOpenPresentation] = useState(false);
  const [pictureUrl, setPictureUrl] = useState<string>();

  useQuery(
    ['picture', currentUser.profilePictureId],
    () => Download(currentUser.profilePictureId ?? ''),
    {
      onSuccess: (response) => {
        if (response) {
          setPictureUrl(URL.createObjectURL(response));
        }
      },
      enabled: !!currentUser.profilePictureId,
      refetchOnWindowFocus: true,
      retryDelay: 10000,
    },
  );

  const fullName = `${currentUser?.firstName ?? ''} ${
    currentUser?.lastName?.split(' ').pop() ?? ''
  }`.toUpperCase();

  return (
    <Container>
      <AvatarWrapper>
        <Avatar
          sx={{ width: 60, height: 60 }}
          alt={currentUser.firstName}
          src={pictureUrl || userIcon}
        />
      </AvatarWrapper>
      <StyledCard>
        <CardHeader>
          <div className="name">
            <Tooltip title={fullName} arrow>
              <span>{fullName}</span>
            </Tooltip>
          </div>
          <div>
            {currentUser?.profileType === UserProfileType.LAWYER ? (
              currentUser?.isVerified && (
                <Tooltip disableInteractive title="Número de inscrição regular no CNA/OAB">
                  <Icon colorSVG="tertiary_500">
                    <Verified />
                  </Icon>
                </Tooltip>
              )
            ) : (
              // <Tooltip disableInteractive title="Usuário não é um advogado">
              <Icon colorSVG="yellow_200">
                <Verified />
              </Icon>
              // </Tooltip>
            )}
          </div>
        </CardHeader>
        <CardContent>
          {showEmail ? <p>{currentUser.email ?? ''}</p> : <div />}
          {currentUser.presentation ? (
            <div style={{ paddingRight: '5px' }}>
              {onViewDetails && (
                <IconButton onClick={() => setIsOpenPresentation(true)}>
                  <RemoveRedEye />
                </IconButton>
              )}
            </div>
          ) : (
            <div />
          )}
        </CardContent>
      </StyledCard>
      {currentUser.presentation && (
        <ModalViewPresentation
          presentation={currentUser.presentation}
          isOpen={isOpenPresentation}
          onRequestClose={() => setIsOpenPresentation(false)}
        />
      )}
    </Container>
  );
}
